export default defineI18nConfig(() => ({
  fallbackLocale: 'ar'
}))
